import useDelayedLoadOptions from 'app/hooks/useDelayedLoadOptions'
import Typeahead from 'app/shared-components/Typeahead'
import useLabel from 'app/hooks/useLabel'
import {
    AdditionalFeeSelectorType,
} from 'app/Apps/OrderManagement/Orders/orders.types'

import requests from 'app/requests/Order/OrderBilling.requests'
import useLoadLabelAdditionalFee from '../hooks/useLoadLabelAdditionalFee'
import useStyles from './AdditionalFeesSelector.style'

const optionsParser = (laneFees: AdditionalFeeSelectorType[]) => {
    return laneFees.map(({
        additionalFeesNumber, id,
    }) => {
        return {
            label: additionalFeesNumber,
            value: id,
            id,
        }
    })
}

type Props = {
    value?: number,
    onChange: (value: any, ...params: any[]) => void,
    orderNumber: string,
}

const defaultProps = {
    value: undefined,
}

const AdditionalFeesSelector = ({
    orderNumber,
    onChange,
    value,
}: Props) => {
    const l = useLabel()
    const {
        classes,
    } = useStyles()

    const loadOptions = useDelayedLoadOptions({
        url: requests.filterApplicableAdditionalFees({
            orderNumber,
        }).url,
        convertion: optionsParser,
    })

    const {
        data,
    } = useLoadLabelAdditionalFee(value)

    return (
        <Typeahead
            name="additionalFee"
            value={value}
            title={l('OutgoingInvoice.laneFee')}
            onChange={onChange}
            loadOptions={loadOptions}
            labelData={data}
            labelField="additionalFeesNumber"
            classNames={{
                options: classes.options,
            }}
        />
    )
}

AdditionalFeesSelector.defaultProps = defaultProps

export default AdditionalFeesSelector
